import React, { useState, useEffect, useContext } from "react";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";

import { AnalisisCreditoContext } from "./AnalisisCreditoScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { FormatMoney } from "../../Helpers/FormatNumber";
import { AnalisisCreditoFiltro } from "./AnalisisCreditoFiltro";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const meses = [
  "ENERO",
  "FEBRERO",
  "MARZO",
  "ABRIL",
  "MAYO",
  "JUNIO",
  "JULIO",
  "AGOSTO",
  "SEPTIEMBRE",
  "OCTUBRE",
  "NOVIEMBRE",
  "DICIEMBRE",
];

export const AnalisisCreditoResultadosOperacionScreen = () => {
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const { state, setState } = useContext(AnalisisCreditoContext);

  const [filtrocargado, setFiltroCargado] = useState({
    periodo: "",
    ejercicio: "",
    linea: "",
  });

  const [solicitudes, setSolicitudes] = useState({
    tablero: [],
    tabla: [],
    vendedores: [],
    sucursales: [],
  });
  const [filtroAbierto, setFiltroAbierto] = useState(false);

  const { titulo, ejercicio, periodo, linea } = location.Roperaciones;

  useEffect(() => {
    setFiltroCargado({
      periodo: periodo || "",
      ejercicio: ejercicio || "",
      linea: linea || "",
    });
  }, [periodo, ejercicio, linea]);

  const handleRedirect = () => {
    localStorage.setItem('filtrocargado', JSON.stringify(filtrocargado));
  
    history.push('/Ventas/SolicitudesCreditoFacturadas');
  };

  const nombreMes = meses[periodo - 1];

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `AnalisisCreditoTablero/GetTableroMes?ejercicio=${ejercicio}&periodo=${periodo}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setSolicitudes({
          tablero: result.tablero,
          tabla: result.tablero,
          vendedores: result.vendedor,
          sucursales: result.sucursal,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
      });
  }, []);

  const onOpenSolicitud = (folio, cliente) => {
    // Guardar los datos en el state local
    setState({
      ...state,
      folio,
      cliente,
    });
  
    // Redirigir y pasar datos por history.push
    history.push({
      pathname: "/SolicitudCredito/Detalle",
      state: {
        folio,
        cliente,
      },
      Roperaciones: {
        titulo: titulo,
        ejercicio: ejercicio,
        periodo: periodo,
        linea: linea,
      },
    });
  };

  //Filtros
  const [filtroRazonSocial, setFiltroRazonSocial] = useState([]);
  const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState([]);
  const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState([]);
  const [filtroSucursal, setFiltroSucursal] = useState([]);
  const [filtroVendedor, setFiltroVendedor] = useState([]);
  const [filtroFolio, setFiltroFolio] = useState([]);
  const onFiltrar = (
    folio,
    asesor,
    razon_social,
    sucursal,
    estado,
    tipo_solicitud,
    linea_credito
  ) => {
    return new Promise((resolve, reject) => {
      var newtabla = solicitudes.tablero;
      //folio
      if (folio != undefined && folio !== null && folio != "") {
        newtabla = newtabla.filter((item) => item.folio === folio);
      } else {
        //Asesor
        if (asesor != undefined && asesor !== null && asesor != "") {
          newtabla = newtabla.filter((item) => item.vendedor === asesor);
        }
        //Razon Social
        if (
          razon_social != undefined &&
          razon_social !== null &&
          razon_social != ""
        ) {
          newtabla = newtabla.filter(
            (item) => item.razon_social === razon_social
          );
        }
        //Sucursal
        if (sucursal != undefined && sucursal !== null && sucursal != "") {
          newtabla = newtabla.filter((item) => item.sucursal === sucursal);
        }
        //Estado
        if (estado != undefined && estado !== null && estado != "") {
          newtabla = newtabla.filter((item) => item.estado === estado);
        }
        //Tipo de solicitud
        if (
          tipo_solicitud != undefined &&
          tipo_solicitud !== null &&
          tipo_solicitud != ""
        ) {
          newtabla = newtabla.filter(
            (item) => item.tipo_credito === tipo_solicitud
          );
        }

        //linea de credito
        if (
          linea_credito != undefined &&
          linea_credito !== null &&
          linea_credito != ""
        ) {
          newtabla = newtabla.filter(
            (item) => item.linea_credito === linea_credito
          );
        }
      }
      setSolicitudes({ ...solicitudes, tabla: newtabla });
      resolve("");
      return;
    });
  };
  const RazonSocial = Array.from(
    new Set(solicitudes.tablero.map((item) => item.razon_social))
  );

  const TipoSolicitud = Array.from(
    new Set(solicitudes.tablero.map((item) => item.tipo_credito))
  );

  const LineaCredito = Array.from(
    new Set(solicitudes.tablero.map((item) => item.linea_credito))
  );

  const Estado = Array.from(
    new Set(solicitudes.tablero.map((item) => item.estado))
  );

  const Sucursal = Array.from(
    new Set(solicitudes.tablero.map((item) => item.sucursal))
  );

  const Vendedor = Array.from(
    new Set(solicitudes.tablero.map((item) => item.vendedor))
  );

  const Folio = Array.from(
    new Set(solicitudes.tablero.map((item) => item.folio))
  );

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const resetFiltros = () => {
    setFiltroRazonSocial([]);
    setFiltroTipoSolicitud([]);
    setFiltroLineaCredito([]);
    setFiltroEstado([]);
    setFiltroSucursal([]);
    setFiltroVendedor([]);
  };

  const modalContent = (
    <div className="filtro">
      <div className="head-filtro">
        <div className="titulo-filtrar">
          ESTADO DE SOLICITUD DE CREDITO1
          <span className="cerrar-modal" onClick={handleCloseModal}>
            X
          </span>
        </div>
      </div>
      <div className="dash-presentacion-titulo-barras">
        <div className="dash-presentacion-bl"></div>
        <div className="dash-presentacion-circle"></div>
        <div className="dash-presentacion-br"></div>
      </div>

      <div className="filtro-container">
        <div className="modal-container-row-dropdownlist">
          <div className="vendedor-container">
            <div className="filtros-subtitles">VENDEDOR</div>
            <select
              className={`filtro-dropdownlist ${filtroVendedor
                  ? "filtro-dropdownlist-selected"
                  : "filtro-dropdownlist"
                }`}
              value={filtroVendedor}
              onChange={(e) => setFiltroVendedor(e.target.value)}
            >
              <option value="">Selecciona un vendedor</option>
              {Vendedor.map((vendedor) => (
                <option key={vendedor} value={vendedor}>
                  {vendedor}
                </option>
              ))}
            </select>
          </div>
          <div className="razon-social-container">
            <div className="filtros-subtitles">Razon Social</div>
            <select
              className={`filtro-dropdownlist ${filtroRazonSocial
                  ? "filtro-dropdownlist-selected"
                  : "filtro-dropdownlist"
                }`}
              value={filtroRazonSocial}
              onChange={(e) => setFiltroRazonSocial(e.target.value)}
            >
              <option value="">Selecciona una razón social</option>
              {RazonSocial.map((razon_social) => (
                <option key={razon_social} value={razon_social}>
                  {razon_social}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="modal-container-row-dropdownlist">
          <div className="sucursal-container">
            <div className="filtros-subtitles">SUCURSAL</div>
            <select
              className="filtro-dropdownlist"
              value={filtroSucursal}
              onChange={(e) => setFiltroSucursal(e.target.value)}
            >
              <option value="">Selecciona una sucursal</option>
              {Sucursal.map((sucursal) => (
                <option key={sucursal} value={sucursal}>
                  {sucursal}
                </option>
              ))}
            </select>
          </div>
          <div>
            <div className="filtros-subtitles">ESTADO</div>
            <select
              className="filtro-dropdownlist"
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              <option value="">Selecciona un estado</option>
              {Estado.map((estado) => (
                <option key={estado} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="modal-container-row-dropdownlist">
          <div>
            <h3 className="filtros-subtitles">Tipo de solicitud</h3>
            <select
              className="filtro-dropdownlist"
              value={filtroTipoSolicitud}
              onChange={(e) => setFiltroTipoSolicitud(e.target.value)}
            >
              <option value="">Selecciona el tipo de solicitud</option>
              {TipoSolicitud.map((tipo_credito) => (
                <option key={tipo_credito} value={tipo_credito}>
                  {tipo_credito}
                </option>
              ))}
            </select>
          </div>
          <div>
            <h3 className="filtros-subtitles">LINEA DE CREDITO</h3>
            <select
              className="filtro-dropdownlist"
              value={filtroLineaCredito}
              onChange={(e) => setFiltroLineaCredito(e.target.value)}
            >
              <option value="">Selecciona el tipo de linea</option>
              {LineaCredito.map((linea_credito) => (
                <option key={linea_credito} value={linea_credito}>
                  {linea_credito}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="boton-restablecer" onClick={resetFiltros}>
        RESTABLECER
      </div>
      {/* <div className="cerrar-modal" onClick={handleCloseModal}>
        <span>CERRAR</span>
      </div> */}
    </div>
  );

  const toggleFiltro = () => {
    setFiltroAbierto(!filtroAbierto);
  };

  // Contador de solicitudes visibles
  const numeroDeSolicitudes = solicitudes.tabla.length;

  return (
    <PlantillaScreen
      titulo={`${titulo} ${nombreMes}`}
      className={"analisis-solicitud-credito-plantilla"}
      className_main={1}
    >
      <div className="analisis-solicitud-credito">
        <LoaderScreen loader={loader} />
        <div className="analisis-solicitud-credito-pendientes-container-filtros">
              {/* {filtroAbierto && (
                <AnalisisCreditoFiltro
                // Props que puedas necesitar pasar al componente
                />
              )} */}
              <div
                className="analisis-solicitud-credito-actions-regresar"
                onClick={handleRedirect}
              >
                <ArrowBackIcon /> Regresar
              </div>
              <AnalisisCreditoFiltro
                tablero={solicitudes.tablero}
                filtroRazonSocialB={filtroRazonSocial}
                setFiltroRazonSocialB={setFiltroRazonSocial}
                filtroTipoSolicitudB={filtroTipoSolicitud}
                setFiltroTipoSolicitudB={setFiltroTipoSolicitud}
                filtroLineaCreditoB={filtroLineaCredito} 
                setFiltroLineaCreditoB={setFiltroLineaCredito}
                filtroEstadoB={filtroEstado}
                setFiltroEstadoB={setFiltroEstado}
                filtroSucursalB={filtroSucursal}
                setFiltroSucursalB={setFiltroSucursal}
                filtroVendedorB={filtroVendedor}
                setFiltroVendedorB={setFiltroVendedor}
                setFiltroFolioB={setFiltroFolio}
                filtroFolioB={filtroFolio}
                onFiltrar={onFiltrar}
              />
              {/* <div
                onClick={handleOpenModal}
                style={{ cursor: "pointer" }}
                className="btn-filtrar"
              >
                <TuneIcon /> FILTRO
              </div> */}
              <Modal open={openModal} onClose={handleCloseModal}>
                {modalContent}
              </Modal>
            </div>

        {solicitudes.tablero === undefined ||
          solicitudes.tablero === null ||
          solicitudes.tablero.length === 0 ? (
          <div></div>
        ) : (
          <div className="analisis-solicitud-credito-container">
            <div className="contador-solicitudes">
                Número de operaciones: {numeroDeSolicitudes}
              </div>
            <div className="analisis-solicitud-credito-container-table scroll-4">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr className="tr-columnas">
                    <th>SUCURSAL</th>
                    <th>
                      <div>CLIENTE</div>
                    </th>
                    <th>
                      <div>ASESOR DE VENTA</div>
                    </th>
                    <th>
                      <div>TIPO DE SOLICITUD</div>
                    </th>
                    <th>
                      <div>ESTADO</div>
                    </th>
                    <th>
                      <div>IMPORTE</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {solicitudes.tabla.map((item) => (
                    <tr
                      onClick={() => {
                        if (item.estado === "Elaborando") {
                          Swal.fire(
                            `${titulo} ${nombreMes}`,
                            "Solicitud se encuentra elaborando",
                            "warning"
                          );
                        } else {
                          onOpenSolicitud(item.folio, item.razon_social);
                        }
                      }}
                    >
                      <td>{item.sucursal}</td>
                      <td>{item.razon_social}</td>
                      <td>{item.vendedor}</td>
                      <td>{item.tipo_credito}</td>
                      <td>{item.estado}</td>
                      <td>{FormatMoney(item.importe)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </PlantillaScreen>
  );
};
